import { PolicyDO } from './policy.model';
import { IntimationDO } from './intimation.model'
import { ProposalDO } from './proposal/proposalDO';

export class ComponentOutputDO {
    constructor(private componentName: any, private componentData: any, private emitter?: any, private UItoServerTransform?: any, private baseComponentName?: any) {
        if (emitter)
            this.emitData(this.emitter)
    }

    emitData(emitter$) {
        emitter$.emit({
            componentName: this.componentName,
            componentData: this.componentData,
            UItoServerTransform: this.UItoServerTransform,
            baseComponentName: this.baseComponentName
        })
    }
}

export class IntimationIO {

    intimationDO: IntimationDO = new IntimationDO();
    clientDOs = []

    constructor() { }

    private data() {
        let dummy = {
            "clientDOs": [
                {
                    "blackListedFl": true,
                    "blackListedReasonCd": null,
                    "caseManager": null,
                    "clientAdditionalFieldDOs": [
                        {
                            "caseManager": null,
                            "createdDt": null,
                            "createdUser": null,
                            "fieldKey": null,
                            "fieldValue": null,
                            "fromEffectiveDT": null,
                            "guid": null,
                            "id": 0,
                            "lastEffectiveDt": null,
                            "objectName": null,
                            "updatedDt": null,
                            "updatedUser": null,
                            "versionId": 0
                        }
                    ],
                    "clientAddressList": [
                        {
                            "addressLine1": null,
                            "addressLine2": null,
                            "addressLine3": null,
                            "addressLine4": null,
                            "caseManager": null,
                            "cityCd": null,
                            "clientAddressID": null,
                            "countryCd": null,
                            "createdDt": null,
                            "createdUser": null,
                            "fromEffectiveDT": null,
                            "guid": null,
                            "id": 0,
                            "lastEffectiveDt": null,
                            "objectName": null,
                            "postCode": null,
                            "prefferedFl": true,
                            "stateCd": null,
                            "subTypeCd": null,
                            "talukaCd": null,
                            "typeCd": null,
                            "updatedDt": null,
                            "updatedUser": null,
                            "versionId": 0,
                            "villageCd": null
                        }
                    ],
                    "clientContactDetailsList": [
                        {
                            "caseManager": null,
                            "contactNum": null,
                            "createdDt": null,
                            "createdUser": null,
                            "extensionNum": null,
                            "fromEffectiveDT": null,
                            "guid": null,
                            "id": 0,
                            "isd": null,
                            "lastEffectiveDt": null,
                            "objectName": null,
                            "prefferedFl": true,
                            "std": null,
                            "subTypeCd": null,
                            "typeCd": null,
                            "updatedDt": null,
                            "updatedUser": null,
                            "versionId": 0
                        }
                    ],
                    "clientEmailList": [
                        {
                            "caseManager": null,
                            "createdDt": null,
                            "createdUser": null,
                            "emailId": null,
                            "fromEffectiveDT": null,
                            "guid": null,
                            "id": 0,
                            "lastEffectiveDt": null,
                            "objectName": null,
                            "prefferedFl": true,
                            "typeCd": null,
                            "updatedDt": null,
                            "updatedUser": null,
                            "versionId": 0
                        }
                    ],
                    "clientNum": null,
                    "clientRelationshipDOs": [
                        {
                            "caseManager": null,
                            "clientIdTo": 0,
                            "clientNum": null,
                            "createdDt": null,
                            "createdUser": null,
                            "guid": null,
                            "id": 0,
                            "name": null,
                            "objectName": null,
                            "relationCd": null,
                            "relationshipTypeCd": null,
                            "updatedDt": null,
                            "updatedUser": null,
                            "versionId": 0
                        }
                    ],
                    "clientTypeCd": null,
                    "createdDt": null,
                    "createdUser": null,
                    "deDupStatusCd": null,
                    "duplicateClientNum": null,
                    "duplicateFl": true,
                    "externalClientNum": null,
                    "fieldKey": null,
                    "fieldValue": null,
                    "fromEffectiveDT": null,
                    "guid": null,
                    "id": 0,
                    "lastEffectiveDt": null,
                    "name": null,
                    "objectName": null,
                    "organisationDO": {
                        "caseManager": null,
                        "companyName": null,
                        "companyName1": null,
                        "contactPersonName": null,
                        "createdDt": null,
                        "createdUser": null,
                        "fromEffectiveDT": null,
                        "guid": null,
                        "id": 0,
                        "industryCd": null,
                        "lastEffectiveDt": null,
                        "objectName": null,
                        "otherName": null,
                        "registrationNum": null,
                        "updatedDt": null,
                        "updatedUser": null,
                        "versionId": 0
                    },
                    "personDO": {
                        "age": 0,
                        "caseManager": null,
                        "citizenshipCd": null,
                        "convictedFlag": true,
                        "countryOfBirthCd": null,
                        "createdDt": null,
                        "createdUser": null,
                        "dateOfBirth": "2019-06-03T11:20:22.785Z",
                        "fathersName": null,
                        "firstName": null,
                        "firstName1": null,
                        "fromEffectiveDT": null,
                        "genderCd": null,
                        "givenName": null,
                        "guid": null,
                        "id": 0,
                        "lastEffectiveDt": null,
                        "lastName": null,
                        "lastName1": null,
                        "legalName": null,
                        "maritalStatusCd": null,
                        "middleName": null,
                        "middleName1": null,
                        "mothersMaidenName": null,
                        "name": null,
                        "objectName": null,
                        "otherName": null,
                        "personEmploymentList": [
                            {
                                "caseManager": null,
                                "createdDt": null,
                                "createdUser": null,
                                "fromEffectiveDT": null,
                                "guid": null,
                                "id": 0,
                                "income": 0,
                                "industryCd": null,
                                "lastEffectiveDt": null,
                                "montlyIncome": 0,
                                "natureOfDutyCd": null,
                                "objectName": null,
                                "occupationCd": null,
                                "occupationClassCd": null,
                                "primaryFl": true,
                                "updatedDt": null,
                                "updatedUser": null,
                                "versionId": 0,
                                "yearlyIncomeRangeCd": null
                            }
                        ],
                        "personIdentityList": [
                            {
                                "caseManager": null,
                                "createdDt": null,
                                "createdUser": null,
                                "fromEffectiveDT": null,
                                "guid": null,
                                "id": 0,
                                "identityNum": null,
                                "identityTypeCd": null,
                                "lastEffectiveDt": null,
                                "objectName": null,
                                "updatedDt": null,
                                "updatedUser": null,
                                "versionId": 0
                            }
                        ],
                        "politicalFlag": true,
                        "sourceOfIncomeCd": null,
                        "titleCd": null,
                        "updatedDt": null,
                        "updatedUser": null,
                        "versionId": 0
                    },
                    "preferredEmail": null,
                    "preferredMobileNum": null,
                    "statusCd": null,
                    "updatedDt": null,
                    "updatedUser": null,
                    "versionId": 0
                }
            ],
            "intimationDO": {
                "caseManager": null,
                "causeOfDeathCd": null,
                "clmIntimationNum": null,
                "countryOfDeathCd": null,
                "createdDt": null,
                "createdUser": null,
                "effectiveDt": null,
                "entryDt": "2019-06-03T11:20:22.789Z",
                "errorFl": true,
                "eventDt": null,
                "eventTm": null,
                "eventTypeCd": null,
                "guid": null,
                "id": 0,
                "intimationClientRoles": null,
                "intimationDt": null,
                "intimationHospitalisations": null,
                "intimationMedicalConditions": null,
                "intimationPayments": null,
                "mannerOfLossCd": null,
                "mannerOfLossDesc": null,
                "pendingReqFl": true,
                "placeOfDeathCd": null,
                "placeOfDeathDesc": null,
                "policies": null,
                "receivedDt": null,
                "stageCd": null,
                "statusCd": null,
                "submissionModeCd": null,
                "updatedDt": null,
                "updatedUser": null,
                "warningFl": true
            }
        }

        let dummyclient = {
            "blackListedFl": null,
            "blackListedReasonCd": null,
            "caseManager": null,
            "clientAdditionalFieldDOs": [],
            "clientAddressList": [
                {
                    "addressLine1": "House 101",
                    "addressLine2": "Sussex St",
                    "addressLine3": null,
                    "addressLine4": null,
                    "caseManager": null,
                    "cityCd": null,
                    "clientAddressID": null,
                    "countryCd": null,
                    "createdDt": 1559634756300,
                    "createdUser": "AdminScript",
                    "fromEffectiveDT": null,
                    "guid": null,
                    "id": 1,
                    "lastEffectiveDt": null,
                    "objectName": "ClientAddressDO",
                    "postCode": null,
                    "prefferedFl": true,
                    "stateCd": null,
                    "subTypeCd": null,
                    "talukaCd": null,
                    "typeCd": "RESIDENCE",
                    "updatedDt": null,
                    "updatedUser": null,
                    "versionId": 1,
                    "villageCd": null,
                    "parentObject": null
                },
                {
                    "parentObject": null,
                    "versionId": 1,
                    "guid": null,
                    "createdDt": 1559634756486,
                    "updatedDt": null,
                    "createdUser": "AdminScript",
                    "updatedUser": null,
                    "caseManager": null,
                    "id": 12,
                    "clientAddressID": null,
                    "typeCd": "MAILING",
                    "subTypeCd": null,
                    "addressLine1": "House 701",
                    "addressLine2": "Sussex St",
                    "addressLine3": null,
                    "addressLine4": null,
                    "cityCd": null,
                    "talukaCd": null,
                    "villageCd": null,
                    "stateCd": null,
                    "countryCd": null,
                    "postCode": null,
                    "prefferedFl": false,
                    "fromEffectiveDT": null,
                    "lastEffectiveDt": null,
                    "objectName": "ClientAddressDO"
                }
            ],
            "clientContactDetailsList": [
                {
                    "caseManager": null,
                    "contactNum": "'112233000070",
                    "createdDt": 1559634756643,
                    "createdUser": "AdminScript",
                    "extensionNum": null,
                    "fromEffectiveDT": null,
                    "guid": null,
                    "id": 1,
                    "isd": null,
                    "lastEffectiveDt": null,
                    "objectName": "ClientPhoneDO",
                    "prefferedFl": true,
                    "std": null,
                    "subTypeCd": null,
                    "typeCd": "BUSINESS",
                    "updatedDt": null,
                    "updatedUser": null,
                    "versionId": 1,
                    "parentObject": null
                },
                {
                    "parentObject": null,
                    "versionId": 1,
                    "guid": null,
                    "createdDt": 1559634756673,
                    "updatedDt": null,
                    "createdUser": "AdminScript",
                    "updatedUser": null,
                    "caseManager": null,
                    "id": 12,
                    "typeCd": "HOME",
                    "subTypeCd": null,
                    "contactNum": "'992233000070",
                    "extensionNum": null,
                    "prefferedFl": false,
                    "fromEffectiveDT": null,
                    "lastEffectiveDt": null,
                    "objectName": "ClientPhoneDO",
                    "isd": null,
                    "std": null
                }
            ],
            "clientEmailList": [
                {
                    "caseManager": null,
                    "createdDt": 1559634756550,
                    "createdUser": "AdminScript",
                    "emailId": "John_Smith@testmail.com",
                    "fromEffectiveDT": null,
                    "guid": null,
                    "id": 1,
                    "lastEffectiveDt": null,
                    "objectName": "ClientEmailDO",
                    "prefferedFl": true,
                    "typeCd": "BUSINESS",
                    "updatedDt": null,
                    "updatedUser": null,
                    "versionId": 1,
                    "parentObject": null
                },
                {
                    "parentObject": null,
                    "versionId": 1,
                    "guid": null,
                    "createdDt": 1559634756596,
                    "updatedDt": null,
                    "createdUser": "AdminScript",
                    "updatedUser": null,
                    "caseManager": null,
                    "id": 12,
                    "typeCd": "PERSONAL",
                    "emailId": "John_Smith_1@testmail.com",
                    "prefferedFl": false,
                    "fromEffectiveDT": null,
                    "lastEffectiveDt": null,
                    "objectName": "ClientEmailDO"
                }
            ],
            "clientNum": "C00070",
            "clientRelationshipDOs": [],
            "clientTypeCd": "PERSON",
            "createdDt": 1559634756253,
            "createdUser": "AdminScript",
            "deDupStatusCd": null,
            "duplicateClientNum": null,
            "duplicateFl": null,
            "externalClientNum": null,
            "fieldKey": null,
            "fieldValue": null,
            "fromEffectiveDT": null,
            "guid": "0DBAA611-576A-4AC1-9664-D7B874F4FD11",
            "id": 1,
            "lastEffectiveDt": null,
            "name": "John Smith",
            "objectName": "ClientDO",
            "organisationDO": null,
            "personDO": {
                "age": null,
                "caseManager": null,
                "citizenshipCd": null,
                "convictedFlag": null,
                "countryOfBirthCd": null,
                "createdDt": 1559634756266,
                "createdUser": "AdminScript",
                "dateOfBirth": -19800000,
                "fathersName": null,
                "firstName": "John",
                "firstName1": null,
                "fromEffectiveDT": null,
                "genderCd": "MALE",
                "givenName": null,
                "guid": null,
                "id": 1,
                "lastEffectiveDt": null,
                "lastName": "Smith",
                "lastName1": null,
                "legalName": null,
                "maritalStatusCd": null,
                "middleName": null,
                "middleName1": null,
                "mothersMaidenName": null,
                "name": "John Smith",
                "objectName": "PersonDO",
                "otherName": null,
                "personEmploymentList": [],
                "personIdentityList": [],
                "politicalFlag": null,
                "sourceOfIncomeCd": null,
                "titleCd": null,
                "updatedDt": null,
                "updatedUser": null,
                "versionId": 1,
                "parentObject": null
            },
            "preferredEmail": "John_Smith@testmail.com",
            "preferredMobileNum": null,
            "statusCd": null,
            "updatedDt": null,
            "updatedUser": null,
            "versionId": 1,
            "parentObject": null
        }

        let mockClients = [dummyclient]

        return mockClients
    }


}

export class PolicyIO {

    proposalDO: PolicyDO = new PolicyDO();
    clientDOs = []

    constructor() { }

    private data() {
    }


}

export class ProposalIO {
    proposalDO : ProposalDO = new ProposalDO();
    clientDOs = [];
    
    constructor() { }

    private data() {
    }

}